import { documentDefaultValues } from "./FormGroups/DocumentFormGroup";
import { quickChanceDefaultValues } from "./FormGroups/QuickChanceFormGroup";

export const defaultValues = {
  ...documentDefaultValues,
  ...quickChanceDefaultValues,
};
